import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { NotificationInline } from 'components/notifications';
import { FormHeading } from 'components/form-fields';

export function SubmissionPrivacyNotice() {
    const emailAddress = useSelector(state => state.loggedInUser.email);

    return (
        <Fragment>
            <NotificationInline
                intent="info"
                show={true}
                allowClose={false}
                text="Your details will only be used to contact you in regards to this submission"
            />
            <div className="form-field">
                <FormHeading headingLevel="h4">Email</FormHeading>
                <p>{emailAddress}</p>
            </div>
        </Fragment>
    );
}